import React from "react";
import { useNavigate } from "react-router-dom";

const ReportTileCard = ({ report }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (report?.path) {
      navigate(report.path);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      className="group relative flex flex-col justify-between rounded-xl border border-slate-200/90 bg-white p-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-400 hover:shadow-md dark:border-slate-800 dark:bg-slate-850 dark:hover:border-primary-500 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-500/40"
    >
      <div>
        {/* Top Header: Icon & Category */}
        <div className="flex items-center justify-between gap-2">
          <div
            className={`flex h-9 w-9 items-center justify-center rounded-lg transition-transform duration-200 group-hover:scale-105 ${report.iconBg}`}
          >
            <i className={`${report.icon} text-sm`} />
          </div>

          <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600 dark:bg-slate-800 dark:text-slate-300">
            {report.categoryLabel}
          </span>
        </div>

        {/* Title & Description */}
        <div className="mt-3">
          <h3 className="text-sm font-semibold text-slate-900 transition-colors duration-200 group-hover:text-primary-600 dark:text-white dark:group-hover:text-primary-400">
            {report.title}
          </h3>
          <p className="mt-1 text-xs leading-relaxed text-slate-500 dark:text-slate-400 line-clamp-2">
            {report.description}
          </p>
        </div>
      </div>

      {/* Footer link */}
      <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-2.5 dark:border-slate-800">
        <span className="text-[11px] font-medium text-slate-500 transition-colors group-hover:text-primary-600 dark:text-slate-400 dark:group-hover:text-primary-400">
          View Report
        </span>
        <i className="fa-solid fa-arrow-right text-[10px] text-slate-400 transition-all duration-200 group-hover:translate-x-1 group-hover:text-primary-600 dark:text-slate-500 dark:group-hover:text-primary-400" />
      </div>
    </div>
  );
};

export default ReportTileCard;
